import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { Staff } from './StaffForm';

interface Group {
  id: number;
  name: string;
}

interface AccessModalProps {
  staff: Staff;
  onSuccess: () => void;
  onCancel: () => void;
}

const AccessModal: React.FC<AccessModalProps> = ({ staff, onSuccess, onCancel }) => {
  const [groups, setGroups] = useState<Group[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<number | ''>('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const response = await api.get('groups/');
        setGroups(response.data);
      } catch (error) {
        console.error('Failed to fetch groups', error);
      }
    };
    fetchGroups();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedGroup) return;

    setLoading(true);
    try {
      await api.post(`staff/${staff.id}/create_access/`, 
        { group_id: selectedGroup }
      );
      alert('Acesso criado com sucesso! Um e-mail com as credenciais de acesso foi enviado para o colaborador.');
      onSuccess();
    } catch (error) {
      console.error('Failed to create access', error);
      alert('Erro ao criar acesso. Verifique se o usuário já existe.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
    }}>
      <div className="card" style={{ width: '400px', maxWidth: '90%' }}>
        <h3>Gerar Acesso ao Sistema</h3>
        <p>Colaborador: <strong>{staff.name}</strong></p>
        <p style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
          Selecione o perfil de acesso para este colaborador.
        </p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Perfil de Acesso</label>
            <select 
              value={selectedGroup} 
              onChange={(e) => setSelectedGroup(Number(e.target.value))} 
              required
            >
              <option value="">Selecione um perfil...</option>
              {groups.map(group => (
                <option key={group.id} value={group.id}>{group.name}</option>
              ))}
            </select>
          </div>

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
            <button type="button" onClick={onCancel} className="btn btn-secondary" disabled={loading}>Cancelar</button>
            <button type="submit" className="btn" disabled={loading || !selectedGroup}>
              {loading ? 'Gerando...' : 'Confirmar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AccessModal;
